<form #econsent="ngForm">
  <section>
    <header
      class="bl-display-sm--flex bl-text-align--center bl-text-align-sm--left bl-text-align--center bl-margin-bottom--16 bl-text-align--center"
    >
      <p class="bl-text-style--display-3 bl-margin--0">{{ primaryEconsent?.heading }}</p>
    </header>

    <div class="bl-display--flex bl-text-style--default-text-1">
      @if (primaryEconsent?.description) {
      <p class="bl-margin--0 bl-overflow-wrap--break-word" [innerHtml]="primaryEconsent.description | safe : 'html'"></p>
      }
    </div>

    <div class="bl-check-wrap bl-margin-top--24 bl-margin-bottom--8" [class.bl-disabled]="!field?.enabled">
      <dx-consent
        [enabled]="field?.enabled"
        [consent]="primaryEconsent"
        [consentField]="field"
        [required]="true"
        [isSubmitted]="isSubmitClicked"
        #pFieldValue="ngModel"
        name="primaryconsent"
        [(ngModel)]="field.data.value"
        [consents]="consentLibrary"
        (selectionChange)="captureContent(primaryEconsent)"
        [fieldId]="'primaryconsent'"
      ></dx-consent>

      @for (consent of eConsents; track consent.acknowledgeId; let i = $index) {
      <dx-consent
        [enabled]="field?.enabled"
        [consentField]="field"
        [consent]="consent"
        [required]="consent.required"
        [isSubmitted]="isSubmitClicked"
        #fieldValue="ngModel"
        [(ngModel)]="consent.isAccepted"
        [consents]="consentLibrary"
        (selectionChange)="captureContent(consent)"
        name="splash-screen-additional-{{ i }}"
        fieldId="splash-screen-additional-{{ i }}"
      ></dx-consent>
      }
    </div>

    <div class="bl-row bl-no-gutters bl-justify-content--center bl-padding-top--32 bl-flex-direction--row">
      <button class="bl-button bl-width--100 bl-bg-color-primary" id="btn-accept-consent" (click)="navigatetoNextPage()">
        <span class="bl-font-size--14 bl-font-weight--700">
          {{ 'econsentSplashPage/begin' | dictionary }}
        </span>
      </button>
    </div>
  </section>
</form>
